import { combineReducers, createReduxStore, register } from "@wordpress/data";
import {
	advancedViewActions,
	advancedViewReducer,
	advancedViewSelectors,
	getInitialAdvancedViewState,
} from "./advanced-view";
import { merge } from "lodash";
import {
	bookActions,
	bookReducer,
	bookSelectors,
	getInitialBookState,
} from "./book";

export const STORE_NAME = "@bbt-israel/online-book";

const createStore = ({ initialState }) => {
	return createReduxStore(STORE_NAME, {
		actions: {
			...advancedViewActions,
			...bookActions,
		},
		selectors: {
			...advancedViewSelectors,
			...bookSelectors,
		},
		initialState: merge(
			{},
			{
				advancedView: getInitialAdvancedViewState(),
				book: getInitialBookState(),
			},
			initialState,
		),
		reducer: combineReducers({
			advancedView: advancedViewReducer,
			book: bookReducer,
		}),
		controls: {},
	});
};

/**
 * Registers the store to WP data's default registry.
 * @param          initialState.initialState
 * @param {Object} [initialState]            Initial state.
 * @return {void}
 */
const registerStore = ({ initialState = {} } = {}) => {
	register(createStore({ initialState }));
};

export default registerStore;
